export default __webpack_public_path__ + "static/media/portada_Panel01.da4624d4.jpg";